// extracted by mini-css-extract-plugin
export default {"roundBadge":"RoundBadge_roundBadge__1wC9Y","small":"RoundBadge_small__OOAox"};